import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getUnprocessedItems, getOutstandingTotal } from 'helpers/accounting';

import {
  BadgeAlt,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from '@cargomatic/ui';

import { withTranslation } from 'react-i18next';
import formatMoney from 'utils/formatters/Money';
import { Disclosure } from '@headlessui/react';
import { ChevronRight, ChevronUp } from 'lucide-react';
import { featureEnabled, CONFIGURED_FEATURES } from 'helpers/feature-flags';

class ChargeItem extends Component {
  constructor(props) {
    super(props);
    this.state = { expanded: false };
  }

  getOutstandingTotal() {
    const { ledgerType, shipment } = this.props;
    return getOutstandingTotal(shipment, ledgerType);
  }

  getFormattedTotal() {
    const amount = this.getOutstandingTotal();
    return formatMoney(amount, this.props.currency);
  }

  handleToggleExpand = () => {
    this.setState((prevState) => ({ expanded: !prevState.expanded }));
  };

  render() {
    const { shipment, t } = this.props;
    const missingDocsLabel = featureEnabled(CONFIGURED_FEATURES.SSR)
      ? 'MISSING_DOCS'
      : 'MISSING_POD';

    return (
      <Disclosure>
        {({ open }) => (
          <div className="border-b last:border-b-0">
            <Disclosure.Button className="w-full px-4 py-3 flex items-center justify-between hover:bg-muted/50 transition-colors">
              <div className="flex items-center gap-2">
                <span className="font-medium text-sm">
                  {shipment.shipment_id}
                </span>
                {shipment.missing_docs && (
                  <BadgeAlt
                    variant="outline"
                    className="bg-red-100 text-red-800 border-red-300 text-xs"
                  >
                    {t(missingDocsLabel)}
                  </BadgeAlt>
                )}
              </div>
              <div className="flex items-center gap-4">
                {!open && (
                  <span className="text-sm">{this.getFormattedTotal()}</span>
                )}
                {open ? (
                  <ChevronUp className="h-4 w-4 text-muted-foreground" />
                ) : (
                  <ChevronRight className="h-4 w-4 text-muted-foreground" />
                )}
              </div>
            </Disclosure.Button>
            <Disclosure.Panel>
              <div className="bg-muted/30 border-t">
                <Table>
                  <TableBody>
                    {getUnprocessedItems(shipment, this.props.ledgerType).map(
                      (adjustment) => (
                        <TableRow
                          key={adjustment._id}
                          className="border-b-0 hover:bg-transparent"
                        >
                          <TableCell className="py-1.5 pl-6 text-sm text-muted-foreground">
                            {adjustment.message}
                          </TableCell>
                          <TableCell className="py-1.5 pr-6 text-sm text-right tabular-nums">
                            {formatMoney(adjustment.value, this.props.currency)}
                          </TableCell>
                        </TableRow>
                      ),
                    )}
                    <TableRow className="hover:bg-transparent">
                      <TableCell className="py-1.5 pl-6 text-sm font-medium border-t">
                        {t('TOTAL')}:
                      </TableCell>
                      <TableCell className="py-1.5 pr-6 text-sm font-medium text-right tabular-nums border-t">
                        {this.getFormattedTotal()}
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </div>
            </Disclosure.Panel>
          </div>
        )}
      </Disclosure>
    );
  }
}

ChargeItem.propTypes = {
  shipment: PropTypes.object,
  isEven: PropTypes.bool,
  ledgerType: PropTypes.oneOf(['receivables', 'payables']),
};

export default withTranslation()(ChargeItem);
